export const breakpoints = {
  mobile: '375px',
  mobileL: '425px',
  tablet: '768px',
  tabletM: '868px',
  laptop: '1024px',
  desktop: '1280px',
};